import type { AppModule } from './app-module.types';
import { HomeIcon, SettingsIcon } from '@/shared/icons';
import { HomePage } from '@/pages/home-page';
import { SettingsPage } from '@/pages/settings-page';

/**
 * "Módulo" do shell da aplicação — análogo aos controllers que o próprio
 * AppModule do NestJS pode declarar. Reúne as páginas cross-cutting que não
 * pertencem a um módulo de domínio específico (a home e as Configurações da
 * aplicação), mantidas em `src/pages/` conforme a convenção do projeto.
 *
 * Dados pessoais e segurança da conta vivem no user-dashboard (acessível via
 * "Minha Conta" no menu do avatar); aqui ficam só a home e as configurações da
 * aplicação (tema + "Visualizar como" admin).
 */
export const shellModule: AppModule = {
  name: 'shell',

  routes: [
    { index: true, element: <HomePage /> },
    { path: 'settings', element: <SettingsPage /> },
  ],

  menu: [
    {
      label: 'Início',
      to: '/',
      icon: HomeIcon,
      section: 'main',
      order: 0,
    },
    {
      label: 'Configurações',
      to: '/settings',
      icon: SettingsIcon,
      section: 'main',
      order: 3,
    },
  ],
};
